"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  Prestep_ExternalAccountAlreadyConnected: 'External account already connected',
  Prestep_InvitationCodeNotFound: 'Invalid code',
  Prestep_RegistrationFailed: 'Registration failed. Please try again later.',
  Prestep_UnauthorizedAccess: 'Unauthorized access',
  birthDate_DoesntMatchUniqueId: 'Date of birth does not match your Unique ID',
  birthDate_LegalRequirementsFailed: 'You must be {MinAge} or older',
  birthDate_OutOfRange: 'Date of birth is not valid',
  customer_NotEligible: 'You are not eligible for customer upgrade.',
  customer_NotUnique: 'You cannot register at the moment. Please contact {customerServiceLink}.',
  document_ExpirationTooSoon: 'Your document will expire too soon.',
  errorOccured: 'An error occured',
  fileTypeIsNotSupported: 'File type is not supported. Try uploading jpg or png',
  loginLinkLabel: 'logging in',
  passwordRequirementCharactersCount: '{min}+ characters',
  passwordRequirementDigit: 'Numbers',
  passwordRequirementLetter: 'Letter',
  passwordRequirementLowerCaseLetter: 'Lower case letters',
  passwordRequirementSpecialCharacter: 'Special characters',
  passwordRequirementUpperCaseLetter: 'Upper case letters',
  sponsorChangeBlockedSponsor: 'You cannot accept the invitation, sponsor is blocked.',
  sponsorChangeNotExistingSponsor: 'You cannot accept the invitation, sponsor is not existing.',
  termsAndConditions_Mandatory: 'Terms and conditions have to be accepted.',
  validationBirthDateRegex: 'Birth date format should be {correctFormat}, e.g. 24.12.2000',
  validationDateRegex: 'Date format should be {correctFormat}, e.g. 24.12.2000',
  validationEmailIsAlreadyUsed: 'Email is already used. Try {loginLink} instead',
  validationEmailTerminatedCustomer: 'Cannot change email for terminated customer',
  validationLength: 'Invalid property length',
  validationMandatoryPropertyIsNull: 'This field is required',
  validationMaxLength: 'Maximum {max} characters',
  validationMaxSize: 'File size exceeded limit',
  validationMaxValue: 'The date should not be later than {max}',
  validationMinLength: 'Minimum {min} characters',
  validationMinValue: 'The date should be later than {min}',
  validationRegex: 'This field is not filled in correctly',
  validationRegexBirthDate: 'Please enter your date of birth in the right format DD.MM.YYYY',
  validationRegexEmail: 'Please enter a valid email in the format my@mail.com',
  validationRegexIdentityCardDateExpiration: 'The date should not be later than {max}',
  validationRegexPhone: 'Please enter a valid phone in the format +46XXXXXXXXX',
  validationRegexUniqueID: 'Please enter a valid Unique ID in the format 123456',
  validationRequired: 'This field is required',
  validationSingleFile: 'Customer can have only single not approved document per document type',
  validationUniqueAlias: 'Alias is already used',
  validationUniqueBankAccount: 'Bank account is already used',
  validationUniqueCustomerAttribute: 'Attribute is already used',
  validationUniqueDisplayName: 'Display name is already used',
  validationUniquePhone: 'Phone is already used. Try {loginLink} instead',
  validationUniqueTaxCode: 'Tax code is already used',
  validationUniqueTaxCode2: 'Tax code 2 is already used',
  validationUniqueUniqueId: 'Unique ID is already used',
  validationValidConfirmationCode: 'Confirmation code is not valid',
  validationValidOldPassword: 'Password does not match to existing password',
  validationValidPhone: 'Phone is not valid',
  validationValidSponsorNumber: 'Sponsor number is not valid',
  validationValidUniqueId: 'Unique ID is not valid',
  validationXmlCharacters: 'Property contains not supported character',
  validationZipCodeStructure: 'Address does not match zip code structure'
};
const translationsNamespace = exports.translationsNamespace = 'common-form-fields';
//# sourceMappingURL=defaultTranslations.js.map